import { render, staticRenderFns } from "./ECSelect.vue?vue&type=template&id=454e9438&scoped=true&"
import script from "./ECSelect.vue?vue&type=script&lang=js&"
export * from "./ECSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e9438",
  null
  
)

export default component.exports